import { render, staticRenderFns } from "./HomeScreen.vue?vue&type=template&id=38877068&scoped=true&"
import script from "./HomeScreen.vue?vue&type=script&lang=js&"
export * from "./HomeScreen.vue?vue&type=script&lang=js&"
import style0 from "./HomeScreen.vue?vue&type=style&index=0&id=38877068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38877068",
  null
  
)

export default component.exports